import React, { Fragment } from 'react';
import joi from 'joi-browser';
import { Button, message } from 'antd';
import BaseForm from '../../components/BaseForm/indexNew';
import CreditCard from './components/CreditCard';
import { subscribe } from '../../services/providers/subscriptions';

// TODO: Need know who its
// sk_test_O95jUYyaCn1fzy6R9PeR5uOG
// pk_test_XnSqD1CKNLDQu5Kn3LUadGTX

class Cards extends BaseForm {
  validationSchema = joi.object({
    stripe_card_id: joi.string().required(),
  });

  state = {
    ...this.state,
    editable: true,
    paymentCards: [{
      id: 1,
      name: 'Test 0',
      exp_month: '08',
      exp_year: '22',
      is_default: true,
      brand: 'MasterCard',
      last4: '4242',
    }],
    success: false,
  };

  returnPaymentMethodRadios = () => {
    return (
      this.props.paymentCards.map(item => ({
        value: item.id,
        name: <CreditCard key={item.id} cardData={item} />,
      }))
    );
  };

  handlePay = async () => {
    const validationData = this.validate();

    if (!validationData) {
      return message.error('Please select card which you want to pay for subscription');
    }

    try {
      await subscribe(validationData.stripe_card_id);
    } catch (e) {
      return message.error('Something went wrong.');
    }

    this.setState({ success: true });
  };

  handlePayAnotherCard = () => {
    this.props.onAddNewCard();
  };

  render() {
    if (this.state.success) {
      return (
        <div className="Result">
          <div className="ResultTitle" role="alert">
            Congratulations!
          </div>
          <div className="ResultMessage">
            Payment successful
          </div>
        </div>
      );
    }

    return (
      <Fragment>
        <div className="CardsWrapper">
          {this.renderRadio('stripe_card_id', {
            required: true,
            data: this.returnPaymentMethodRadios(),
            className: 'children-block no-mark-required',
          })}
          <div className="ActionsWrapper">
            <Button
              type="primary"
              block
              onClick={this.handlePay}
            >
              Pay $99.99
            </Button>
            <div
              className="text-center text-link mt-1 cursor-pointer"
              onClick={this.handlePayAnotherCard}
            >
              Pay from another card
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Cards;




// WEBPACK FOOTER //
// ./src/containers/Subscriptions/Cards.js